<template>
    <div>
        <fieldset>
            <legend>
                Grupo 1
            </legend>
            <div class="row">
                <div class="input-field col s5 m5 l5 xl5">
                    <input id="nome" type="text" readonly placeholder="" name="nome" v-model="user.name"/>
                    <label for="nome">Nome</label>
                </div>
                <div class="input-field col s2 m2 l2 xl2">
                    <input id="cpf" type="text"   placeholder="" readonly name="cpf" v-model="user.cpf"/>
                    <label for="cpf">CPF</label>
                </div>
                <div class="input-field col s5 m5 l5 xl5">
                    <input id="nome_social" type="text"  name="nome_social" readonly
                      placeholder=""  v-model="$data[user.nome_social == 'null' ?'': user.nome_social]"/>
                    <label for="nome_social">Nome Social</label>
                </div>
            </div>
            <div class="row">
                <div class="input-field col s12 m6 l6 xl6">
					<label class='active' for="centro">Centro</label><br>
                    <select name="centro_usuario" :disabled="!editable"  @change="getUnits()"
                     id="centro_usuario" v-model="user.unidade.centro.id" 
                     required class="browser-default select_sec">
                        <option value="" disabled selected>Escolha o centro</option>
                        <option v-for="center in this.centersData"
                          v-bind:value="center.id" :key="center.id">{{center.nome}}</option>
                    </select>
                </div>
                <div class="input-field col s12 m6 l6 xl6">
					<label class='active' for="unidade">Unidade</label><br>
                    <select name="unidade_usuario" :disabled="!editable" 
                      v-model="user.unidade.id"
                      required class="browser-default select_sec">
                        <option value="" disabled selected>Escolha a unidade</option>
                        <option v-for="unit in this.unitsData" v-bind:value="unit.id" 
                        :key="unit.id" >{{unit.nome}}</option>
                    </select>
                </div>
            </div>
			<div class="row">
                <div class="input-field col s12 m9 l9 xl9">
					<label class='active' for="localizacao">Localização</label><br>
                    <select name="localizacao" :disabled="!editable"  @change="getUnits()"
                     id="localizacao" v-model="user.localizacao_id" 
                     required class="browser-default select_sec">
                        <option value="" disabled selected>Escolha a localização</option>
                        <option v-if='localizacao.nome.length' v-for="localizacao in this.locs" :value="localizacao.id">{{ localizacao.nome }} - {{ localizacao.codigo }}</option>
                    </select>
                </div>
				<div class="input-field col s12 m3 l3 xl3">
					<input
						id="lattes"
						name="lattes"
						type="text"
						class="validate"
						v-model="user.lattes"
						placeholder='* Lattes'
						title='Insira o ID de 16 dígitos do seu currículo Lattes'
						data-toggle ='tooltip'
						minlength="16"
						maxlength="16"
						pattern="[0-9]+"
						v-bind:class="{ 'red-text': (user.lattes && user.lattes.length != 16), 'green-text': (user.lattes && user.lattes.length == 16) }">
					<label for="lattes">Lattes</label>
				</div>
			</div>
            <div class="row">
                <div class="input-field col s6 m6 l6 xl6">
                    <input id="email" type="email" readonly   placeholder="" name="email" v-model="user.email"/>
                    <label for="email">Email</label>
                    <div style="color:red;">
                        *Para atualizar o e-mail, utilize a <a href="https://intranet.ufrj.br/atualizacao-email">Intranet</a> 
                        <br> (para as atualizações ficarem visíveis, é necessário se deslogar e logar novamente). 
                    </div>
                </div>
                <button type="button" :disabled="!editable"  class="btn waves-effect waves-light" name="btnAtualizarDadosPessoais" @click="btnUpdateData()">Atualizar Dados</button>
            </div>
        </fieldset>
    </div>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import * as constantes from '../constantes.js';
    import { mapState, mapActions } from 'vuex';
    export default {
        name:'Group1',
        props:[
            'centers',
			'localizacoes',
            'editable',
            'userprofiles',
        ],
        components: {
            Loading,
        },
        computed:{
            ...mapState(['project']),
            user(){
                return this.project.curriculo.usuario;
                
                
            }
           
        },
        data(){
            return {
                unitsData:Array,
                centersData:JSON.parse(this.centers),
				locs:JSON.parse(this.localizacoes),
                userProfilesData:this.userprofiles,
                returnUrlData:this.returnurl
            }

        },
        methods:{
            ...mapActions(['setProject']),
            getUnits(){
                if(this.user.unidade.centro.id){ 
                    this.centersData.forEach(center => {
                        if(center.id ==this.user.unidade.centro.id){
                            this.unitsData=center.unidades;
                        }
                    });
                }
                    
            },
            verifyProfile: function(){
                //verifica  se o usuário tem o perfil de técnico.
                let index=this.userProfilesData.indexOf(constantes.PERFIL_TECNICO);
                let isTecnico=(index != -1);
                
                //se não tiver o perfil de técnico remover a administração central.
                if(!isTecnico){
                    this.centersData.forEach((center,index) =>{
                        if(center.id == 10){
                            this.centersData.splice(index,1);
                            return false;
                        }
                            
                    });
                }
              
            },
            btnUpdateData(){
                let formData =new FormData();
                formData.append("unidade",this.user.unidade.id);
				formData.append("localizacao",this.user.localizacao_id);
                formData.append("responderParaMesmaPagina",true);
                formData.append("user_id",this.user.id);
				formData.append("lattes",$("#lattes").val());
                $.ajax({
                    headers:{
                        'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
                    },
                    url:"/dados/false",
                    type:"POST",
                    data:formData,
                    processData:false,
                    contentType:false,
                    success:(response)=>{
                        showMsg(response,200);
                    },
                    error:(response)=>{showMsg(response,500)}
                });
            },
        },
        mounted(){
            setTimeout( ()=>{
                this.getUnits();
            },1000);
            this.verifyProfile();
           
        },
    }
</script>